// Do not edit.
import { ShaderStore } from "../Engines/shaderStore";

const name = "hdrFilteringPixelShader";
const shader = `#include<helperFunctions>
#include<importanceSampling>
#include<pbrBRDFFunctions>
#include<hdrFilteringFunctions>
uniform float alphaG;
uniform samplerCube inputTexture;
uniform vec2 vFilteringInfo;
uniform float hdrScale;
varying vec3 direction;void main() {vec3 color=radiance(alphaG,inputTexture,direction,vFilteringInfo);gl_FragColor=vec4(color*hdrScale,1.0);}`;
// Sideeffect
if (!ShaderStore.ShadersStore[name]) {
    ShaderStore.ShadersStore[name] = shader;
}
ShaderStore._PendingIncludesLoaders.push(() => Promise.all([
    import("./ShadersInclude/helperFunctions"),
    import("./ShadersInclude/importanceSampling"),
    import("./ShadersInclude/pbrBRDFFunctions"),
    import("./ShadersInclude/hdrFilteringFunctions")
]));
/** @internal */
export const hdrFilteringPixelShader = { name, shader };
